import * as React from 'react';
import api from '../api/apiClient';
import moment from 'moment';
import 'moment/locale/is';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from "react-router-dom";
import { Form } from 'react-bootstrap';
import { withRouter } from '../hoc/withRouter';

moment.locale('is');

class EditRacePage extends React.Component<any, any> {

	constructor(props, context) {
		super(props);
		this.saveRace = this.saveRace.bind(this);
	}

	state = {
		eventid: '',
		seriesid: '',
		name: '',
		start: moment(),
		duration: 0,
		laps: 0,
		finishMode: 0,
		finished: false,
		pointsSystem: 0,
		rules: '',
		availableRules: []
	}

	componentDidMount() {
		this.setState({ eventid: this.props.match.params.eventid });

		// The available rules come from the registered IRaceRule implementations, so the
		// keys and labels never have to be duplicated here.
		api.request('races/rules').then(data => this.setState({ availableRules: data || [] }));

		if (this.props.match.params.raceid) {
			this.loadRace(this.props.match.params.raceid);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.raceid !== this.props.match.params.raceid ||
			prevProps.match.params.eventid !== this.props.match.params.eventid) {

			this.setState({ eventid: this.props.match.params.eventid });

			if (this.props.match.params.raceid) {
				this.loadRace(this.props.match.params.raceid);
			} else {
				this.setState({
					eventid: this.props.match.params.eventid,
					seriesid: '',
					name: '',
					start: moment(),
					duration: 0,
					laps: 0,
					finishMode: 0,
					finished: false,
					pointsSystem: 0,
					rules: ''
				});
			}
		}
	}

	loadRace(id) {
		api.request('races/' + id).then(data => {
			this.setState({
				eventid: data.eventId,
				seriesid: data.seriesId,
				name: data.name,
				start: moment(data.start),
				duration: data.duration,
				laps: data.laps || 0,
				finishMode: data.finishMode || 0,
				finished: data.finished,
				pointsSystem: data.pointsSystem || 0,
				rules: data.rules || ''
			});
		});
	}

	addRace(race) {
		// The series is taken from the event server side, and a new race has no series id
		// yet - posting the empty string would fail to bind to Race.SeriesId and null the
		// whole body, so it is left out entirely.
		api.post('races', {
			eventid: race.eventid,
			name: race.name,
			start: race.start,
			duration: race.duration,
			laps: race.laps,
			finishMode: race.finishMode,
			finished: race.finished,
			pointsSystem: race.pointsSystem,
			rules: race.rules
		}).then(data => {
			this.props.history.push('/event/' + this.state.eventid);
		});
	}

	updateRace(id, race) {
		api.put('races/' + id, race).then(response => {
			this.props.history.push('/event/' + this.state.eventid);
		});
	}

	deleteRace(raceId) {
		api.delete('races/' + raceId).then(response => {
			this.props.history.push('/event/' + this.state.eventid);
		});
	}

	saveRace(event) {
		if (this.props.match.params.raceid) {
			this.updateRace(this.props.match.params.raceid, this.state)
		} else {
			this.addRace(this.state);
		}
	}

	hasRule(ruleName) {
		return (this.state.rules || '').split(',').indexOf(ruleName) != -1;
	}

	removeRule(ruleName) {
		var rules = this.state.rules ? this.state.rules.split(',') : new Array();
		var index = rules.indexOf(ruleName);
		if (index != -1) {
			rules.splice(index, 1);
			this.setState({ rules: rules.join(',') });
		}
	}

	addRule(ruleName) {
		var rules = this.state.rules ? this.state.rules.split(',') : new Array();
		var index = rules.indexOf(ruleName, 0);
		if (index == -1) {
			rules.push(ruleName);
			this.setState({ rules: rules.join(',') });
		}
	}

	render() {
		const raceStartDate = moment.isMoment(this.state.start) && this.state.start.isValid() ? this.state.start.toDate() : new Date();
		const isEditing = !!this.props.match.params.raceid;

		return (
			<div>
				<h3>{isEditing ? 'Edit Race' : 'Add Race'}</h3>

				<div>
					<div className="mb-3">
						<label htmlFor="name" className="form-label">Name</label>
						<input type="text" id="name" className="form-control" value={this.state.name} onChange={(event) => this.setState({ name: event.target.value })} />
					</div>

					<div className="mb-3">
						<label htmlFor="start" className="form-label">Date</label>
						<DatePicker id="start" className="form-control" selected={raceStartDate} onChange={(date) => this.setState({ start: moment(date) })} locale="is" />
					</div>

					<div className="mb-3">
						<label htmlFor="startTime" className="form-label">Start Time</label>
						<input type="time" id="startTime" className="form-control" value={this.state.start.format("HH:mm")} onChange={(event) => {
							var time = event.target.value.split(':');
							this.setState({ start: this.state.start.clone().set('hour', Number(time[0])).set('minute', Number(time[1])) });
						}} />
					</div>

					<div className="mb-3">
						<label htmlFor="duration" className="form-label">Duration (minutes)</label>
						<input type="number" id="duration" className="form-control" value={this.state.duration} onChange={(event) => this.setState({ duration: parseInt(event.target.value) || 0 })} />
					</div>

					<div className="mb-3">
						<label htmlFor="laps" className="form-label">Laps</label>
						<input type="number" min="0" id="laps" className="form-control" value={this.state.laps} onChange={(event) => this.setState({ laps: parseInt(event.target.value) || 0 })} />
						<small className="form-text text-muted">
							{this.state.duration > 0
								? 'Extra laps the leader runs after the time expires (e.g. 30 min + 2 laps). Only applies to the leader-finish rule. Leave 0 for a pure time race.'
								: 'Total number of laps. Set a duration above for a timed race.'}
						</small>
					</div>

					<div className="mb-3">
						<label htmlFor="finishMode" className="form-label">Finish Mode</label>
						<Form.Select
							id="finishMode"
							value={this.state.finishMode}
							disabled={!(this.state.duration > 0)}
							onChange={(event) => this.setState({ finishMode: parseInt(event.target.value) })}
						>
							<option value={0}>On leader finish - the flag drops when the leader completes his lap</option>
							<option value={1}>On time expiry - every rider is flagged on their first pass after the clock runs out</option>
						</Form.Select>
						<small className="form-text text-muted">
							{this.state.duration > 0
								? <><strong>On leader finish</strong> is the usual motocross rule: riders who cross the line between the clock expiring and the leader coming round are waved through and run one extra lap.</>
								: <>Not used in a laps-only race - every rider runs the same distance, so both modes finish them identically.</>}
						</small>
					</div>

					<div className="mb-3">
						<label htmlFor="pointsSystem" className="form-label">Points System</label>
						<Form.Select id="pointsSystem" value={this.state.pointsSystem} onChange={(event) => this.setState({ pointsSystem: parseInt(event.target.value) })}>
							<option value={0}>Default (MSI)</option>
							<option value={1}>MSI</option>
							<option value={2}>Wess</option>
						</Form.Select>
					</div>

					<div className="mb-3">
						<label className="form-label">Rules</label>
						{this.state.availableRules.map((rule: any) => (
							<div className="form-check" key={rule.key}>
								<input
									type="checkbox"
									className="form-check-input"
									id={rule.key}
									disabled={!rule.configurable}
									checked={!rule.configurable || this.hasRule(rule.key)}
									onChange={(event) => event.target.checked ? this.addRule(rule.key) : this.removeRule(rule.key)}
								/>
								<label className="form-check-label" htmlFor={rule.key}>
									{rule.name}{!rule.configurable && ' (always applied)'}
								</label>
							</div>
						))}
					</div>

					<div className="mb-3">
						<div className="form-check">
							<input type="checkbox" className="form-check-input" id="finished" checked={this.state.finished} onChange={(event) => this.setState({ finished: event.target.checked })} />
							<label className="form-check-label" htmlFor="finished">Finished</label>
						</div>
					</div>
				</div>

				<div className="btn-group mt-3">
					<Link to={'/event/' + this.state.eventid} className="btn btn-warning">Cancel</Link>
					<button onClick={this.saveRace} className="btn btn-success">Save</button>
					{isEditing &&
						<button onClick={(e) => this.deleteRace(this.props.match.params.raceid)} className="btn btn-danger">Delete</button>
					}
				</div>
			</div>
		)
	}

}

export default withRouter(EditRacePage);
